import React, { FormEvent, useEffect, useState } from "react";
import {
  customStyles,
  ModalA,
  ModalButton,
  ModalClose,
  ModalContentA,
  ModalContentButton,
  ModalFormControl,
  ModalFormControlLabel,
  ModalFormLabel,
  ModalFormularioDiv,
  ModalH2,
  ModalInputLabel,
  ModalOutlinedInput,
  ModalRadio,
  ModalRadioGroup,
} from "./styles";
import Modal from "react-modal";
import { linkDeepaffex } from "../../../Services/Auth";
import { IHealthPlace } from "../../../Services/Interfaces";
import { FormHelperText } from "@mui/material";
import VirtualKeyboard from "./VirtualKeyboard";
import { FaKeyboard } from "react-icons/fa";

interface ModalProps {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  modalIsOpen: boolean;
}

const ModalComponentMedicao: React.FC<ModalProps> = ({ setIsOpen, modalIsOpen }) => {
  Modal.setAppElement("#root");

  const [customer, setCustomer] = useState("");
  const [service, setService] = useState("");
  const [age, setAge] = useState<string>("");
  const [height, setHeight] = useState<string>("");
  const [showErrorHeight, setShowErrorHeight] = useState(false);
  const [weight, setWeight] = useState<string>("");
  const [showErrorWeight, setShowErrorWeight] = useState(false);

  const [gender, setGender] = useState("");
  const [smoking, setSmoking] = useState("");
  const [bloodpressuremedication, setBloodpressuremedication] = useState("");
  const [diabetes, setDiabetes] = useState("");

  const [showKeyboard, setShowKeyboard] = useState(false);
  const [activeField, setActiveField] = useState<"age" | "height" | "weight" | null>(null);

  useEffect(() => {
    const HealthPlaceJSON = localStorage.getItem("HealthPlaceDados");
    if (HealthPlaceJSON) {
      const HealthPlaceDados = JSON.parse(HealthPlaceJSON) as IHealthPlace;
      setCustomer(HealthPlaceDados.customer.deepAffexCallbackId);
      setService(HealthPlaceDados.service.deepAffexCallbackId);
    }
  }, []);

  function closeModal() {
    setCustomer("");
    setService("");
    setAge("");
    setHeight("");
    setWeight("");
    setGender("");
    setSmoking("");
    setBloodpressuremedication("");
    setDiabetes("");
    setIsOpen(false);
  }

  const envioDadosMedicao = async (e: FormEvent) => {
    e.preventDefault();
    const path = await linkDeepaffex(
      JSON.stringify({
        identifier: `${customer}--${service}`,
        age,
        height,
        weight,
        gender,
        smoking,
        bloodpressuremedication,
        diabetes,
      })
    );
    if (path) {
      window.location.href = path.toString();
    }
  };

  function handleInputClick(field: "age" | "height" | "weight") {
    setActiveField(field);
    setShowKeyboard(true);
  }

  function handleKeyboardInput(value: string) {
    if (activeField === "age") {
      setAge(value);
    } else if (activeField === "height") {
      setHeight(value);
    } else if (activeField === "weight") {
      setWeight(value);
    }
  }

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles} contentLabel="Dados pré-medicação">
      <ModalContentA>
        <ModalA onClick={closeModal}>
          <ModalClose />
        </ModalA>
      </ModalContentA>
      <ModalH2>Dados pré-medicação</ModalH2>
      <ModalFormularioDiv onSubmit={envioDadosMedicao}>
        {/* Campo Idade */}
        <ModalFormControl variant="outlined">
          <ModalInputLabel htmlFor="age">Idade</ModalInputLabel>
          <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
              <ModalOutlinedInput
                id="age"
                type="number"
                label="Idade"
                required
                value={age}
                onChange={(e) => setAge(e.target.value)}
                style={{ flex: 1 }}
              />
              <button
                type="button"
                onClick={() => handleInputClick("age")}
                style={{ border: "none", background: "transparent", cursor: "pointer", marginLeft: "8px" }}
              >
                <FaKeyboard size={20} />
              </button>
            </div>
            {showKeyboard && activeField === "age" && (
              <VirtualKeyboard onChange={handleKeyboardInput} onClose={() => setShowKeyboard(false)} currentValue={age} />
            )}
          </div>
        </ModalFormControl>

        {/* Campo Altura */}
        <ModalFormControl variant="outlined" error={showErrorHeight}>
          <ModalInputLabel htmlFor="height">Altura (centímetros)</ModalInputLabel>
          <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
              <ModalOutlinedInput
                id="height"
                type="number"
                label="Altura (centímetros)"
                required
                value={height}
                onChange={(e) => setHeight(e.target.value)}
                style={{ flex: 1 }}
              />
              <button
                type="button"
                onClick={() => handleInputClick("height")}
                style={{ border: "none", background: "transparent", cursor: "pointer", marginLeft: "8px" }}
              >
                <FaKeyboard size={20} />
              </button>
            </div>
            {showErrorHeight && <FormHelperText>Valor não pode ser maior que 251 cm</FormHelperText>}
            {showKeyboard && activeField === "height" && (
              <VirtualKeyboard onChange={handleKeyboardInput} onClose={() => setShowKeyboard(false)} currentValue={height} />
            )}
          </div>
        </ModalFormControl>

        {/* Campo Peso */}
        <ModalFormControl variant="outlined" error={showErrorWeight}>
          <ModalInputLabel htmlFor="weight">Peso</ModalInputLabel>
          <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
              <ModalOutlinedInput
                id="weight"
                type="number"
                label="Peso"
                required
                value={weight}
                onChange={(e) => setWeight(e.target.value)}
                style={{ flex: 1 }}
              />
              <button
                type="button"
                onClick={() => handleInputClick("weight")}
                style={{ border: "none", background: "transparent", cursor: "pointer", marginLeft: "8px" }}
              >
                <FaKeyboard size={20} />
              </button>
            </div>
            {showErrorWeight && <FormHelperText>Valor não pode ser maior que 250 Kg</FormHelperText>}
            {showKeyboard && activeField === "weight" && (
              <VirtualKeyboard onChange={handleKeyboardInput} onClose={() => setShowKeyboard(false)} currentValue={weight} />
            )}
          </div>
        </ModalFormControl>

        {/* Outras informações do formulário */}
        <ModalFormControl>
          <ModalFormLabel>Gênero</ModalFormLabel>
          <ModalRadioGroup row onChange={(e) => setGender(e.target.value)}>
            <ModalFormControlLabel value="male" control={<ModalRadio required />} label="Masculino" />
            <ModalFormControlLabel value="female" control={<ModalRadio required />} label="Feminino" />
          </ModalRadioGroup>
        </ModalFormControl>

        <ModalFormControl>
          <ModalFormLabel>Fumante?</ModalFormLabel>
          <ModalRadioGroup row onChange={(e) => setSmoking(e.target.value)}>
            <ModalFormControlLabel value="1" control={<ModalRadio required />} label="Sim" />
            <ModalFormControlLabel value="0" control={<ModalRadio required />} label="Não" />
          </ModalRadioGroup>
        </ModalFormControl>

        <ModalFormControl>
          <ModalFormLabel>Utiliza medicamento para pressão?</ModalFormLabel>
          <ModalRadioGroup row onChange={(e) => setBloodpressuremedication(e.target.value)}>
            <ModalFormControlLabel value="1" control={<ModalRadio required />} label="Sim" />
            <ModalFormControlLabel value="0" control={<ModalRadio required />} label="Não" />
          </ModalRadioGroup>
        </ModalFormControl>

        <ModalFormControl>
          <ModalFormLabel>Diabetes?</ModalFormLabel>
          <ModalRadioGroup row onChange={(e) => setDiabetes(e.target.value)}>
            <ModalFormControlLabel value="type1" control={<ModalRadio required />} label="Tipo 1" />
            <ModalFormControlLabel value="type2" control={<ModalRadio required />} label="Tipo 2" />
            <ModalFormControlLabel value="0" control={<ModalRadio required />} label="Não" />
          </ModalRadioGroup>
        </ModalFormControl>

        <ModalContentButton>
          <ModalButton title="Medir">Medir</ModalButton>
        </ModalContentButton>
      </ModalFormularioDiv>
    </Modal>
  );
};

export default ModalComponentMedicao;
